function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.85 4.15a.5.5 0 10-.7.7l3.5 3.5a8.1 8.1 0 00-3.37 5.05.5.5 0 10.98.2 7.09 7.09 0 013.1-4.53l1.59 1.59a3.5 3.5 0 104.88 4.88l4.32 4.31a.5.5 0 00.7-.7l-15-15zM12.12 10l3.37 3.37A3.5 3.5 0 0012.12 10z",
  fill: "#1C1C1C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.53 7.41l.8.8C10.87 8.07 11.43 8 12 8c3.2 0 6.06 2.33 6.74 5.6a.5.5 0 10.98-.2A7.97 7.97 0 0012 7c-.86 0-1.69.14-2.47.41z",
  fill: "#1C1C1C"
})));